import React from 'react'
// import {Player} from 'video-react'
import { WhiteSpace, Modal } from 'antd-mobile'
import { get } from 'lodash'
import moment from 'moment'
// import Article from './article'
import Comment from './springComment'
import QuestionActivity from './questionActivity'
import VideoActivity from './videoActivity'
import banner from './images/sharebanner.png'
import isOverActivity from './images/isOver.png'
import './styles/overwrite.css'

export default class Theme extends React.Component {
  render() {
    const activityEndAt = get(this.props, 'theme.theme.endAt')
    const isOver = moment().isAfter(moment(activityEndAt))
    return (
      <div className="theme">
        <div className="theme-banner">
          <img src={banner} />
        </div>
        <div style={{backgroundColor:'white'}}>
          <VideoActivity {...this.props} />
          <QuestionActivity isShare={false} {...this.props} />
          <Comment isShare={false} {...this.props} />
        </div>
        <Modal
          visible={isOver}
          transparent
          maskClosable={false}
        >
          <img
            style={{width: '240px'}}
            src={isOverActivity}
          />
        </Modal>
      </div>
    )
}

}



// WEBPACK FOOTER //
// ./src/modules/theme/components/index.js